module.exports = __webpack_public_path__ + "static/media/ch.9c26f60a.svg";